export const TypeBenefits = {
  NO_BENEFIT_TYPE: 50,
  PRESIDENT_STIPEND_CERTIFICATE: 100,
  DISABILITY_CERTIFICATE: 200,
  FOREIGN_LANGUAGE_MASTER_DIPLOMA: 400,
}

export const DisabilitySubtypes = {
  VISION_IMPAIRMENT: 100,
  HEARING_IMPAIRMENT: 200,
  SPEECH_IMPAIRMENT: 300,
}

export const TypeBenefitsList = [
  {
    id: TypeBenefits.NO_BENEFIT_TYPE,
    uz: 'Mavjud emas',
    ru: 'Отсутствует',
    en: 'Not available',
  },
  {
    id: TypeBenefits.PRESIDENT_STIPEND_CERTIFICATE,
    uz: 'Prezident stipendianti guvohnomasi',
    ru: 'Свидетельство стипендиата Президента',
    en: 'Presidential scholarship certificate',
  },
  {
    id: TypeBenefits.DISABILITY_CERTIFICATE,
    uz: 'Nogironlik guvohnomasi (Koʻrish, eshitish va nutqida nuqsoni boʻlgan shaxslar uchun, PQ-407)',
    ru: 'Свидетельство об инвалидности (для лиц с нарушением зрения, слуха и речи, ПҚ-407)',
    en: 'Disability certificate (for persons with visual, hearing and speech impairments, PQ-407)',
    subtypes: [
      {
        id: DisabilitySubtypes.VISION_IMPAIRMENT,
        uz: 'Ko‘rish nuqsoni',
        ru: 'Нарушение зрения',
        en: 'Visual impairment',
      },
      {
        id: DisabilitySubtypes.HEARING_IMPAIRMENT,
        uz: 'Eshitish nuqsoni',
        ru: 'Нарушение слуха',
        en: 'Hearing impairment',
      },
      {
        id: DisabilitySubtypes.SPEECH_IMPAIRMENT,
        uz: 'Nutq nuqsoni',
        ru: 'Нарушение речи',
        en: 'Speech impairment',
      },
    ],
  },
  {
    id: TypeBenefits.FOREIGN_LANGUAGE_MASTER_DIPLOMA,
    uz: 'Magistraturani xorijiy tilda tugatgan',
    ru: 'Окончил магистратуру на иностранном языке',
    en: 'Completed a master’s degree in a foreign language',
  },
]
